export const IMAGES = {
  latte:
    "https://images.unsplash.com/photo-1787317218716-c17ec9f7b552?q=80&w=1200&auto=format&fit=crop",
  interior:
    "https://images.unsplash.com/photo-1787079487019-31c7ed6d7d6d?q=80&w=1200&auto=format&fit=crop",
  terrace:
    "https://images.unsplash.com/photo-1577056922428-a511301a562d?q=80&w=1200&auto=format&fit=crop",
  entrance:
    "https://images.unsplash.com/photo-1616091216791-a5360b5fc78a?q=80&w=1200&auto=format&fit=crop",
  croissants:
    "https://images.unsplash.com/photo-1555507036-ab1f4038808a?q=80&w=1200&auto=format&fit=crop",
  pastryTray:
    "https://images.unsplash.com/photo-1483695028939-5bb13f8648b0?q=80&w=1400&auto=format&fit=crop",
  breakfast:
    "https://images.unsplash.com/photo-1790418482148-f52e84695e25?q=80&w=1200&auto=format&fit=crop",
  pie: "https://images.unsplash.com/photo-1759593914762-11026921ef2d?q=80&w=1200&auto=format&fit=crop",
};

export const NAV_LINKS = [
  { label: "Le Café", href: "#le-cafe", testid: "nav-link-le-cafe" },
  { label: "La Carte", href: "#la-carte", testid: "nav-link-la-carte" },
  { label: "Galerie", href: "#galerie", testid: "nav-link-galerie" },
  { label: "Horaires", href: "#horaires", testid: "nav-link-horaires" },
  { label: "Contact", href: "#contact", testid: "nav-link-contact" },
];

export const MENU_CATEGORIES = [
  { id: "cafes", label: "Cafés & Boissons", image: IMAGES.latte, note: "Torréfaction artisanale" },
  { id: "patisseries", label: "Pâtisseries", image: IMAGES.croissants, note: "Feuilletage du matin" },
  { id: "petit-dejeuner", label: "Petit-Déjeuner", image: IMAGES.breakfast, note: "Servi jusqu'à 11 h 30" },
  { id: "dejeuner", label: "Déjeuner", image: IMAGES.pie, note: "De 12 h à 14 h 30" },
];

export const MENU = {
  cafes: [
    { name: "Espresso d'Éthiopie", desc: "Torréfaction claire, notes florales et d'agrumes.", price: "2,40 €" },
    { name: "Café crème", desc: "Lait fermier breton, texture soyeuse.", price: "3,60 €" },
    { name: "Flat white", desc: "Double ristretto, lait micro-moussé.", price: "4,20 €" },
    { name: "Cappuccino", desc: "Équilibré, voile de cacao amer en finition.", price: "3,90 €" },
    { name: "Filtre V60", desc: "Café d'origine, extraction douce et lente.", price: "4,50 €", tags: ["Bio"] },
    { name: "Chocolat chaud à l'ancienne", desc: "Chocolat noir 70 %, touche de crème double.", price: "4,80 €" },
    { name: "Latte glacé maison", desc: "Espresso, lait fermier, glace pilée.", price: "4,50 €" },
    { name: "Citronnade artisanale", desc: "Citron, romarin, sucre de canne.", price: "4,00 €" },
  ],
  patisseries: [
    { name: "Croissant au beurre AOP", desc: "Beurre de baratte breton, feuilletage long.", price: "1,70 €" },
    { name: "Pain au chocolat", desc: "Double bâton de chocolat noir.", price: "1,90 €" },
    { name: "Kouign-amann maison", desc: "La spécialité bretonne, caramélisée au beurre demi-sel.", price: "3,40 €" },
    { name: "Tarte fine aux pommes", desc: "Pommes de verger, caramel léger.", price: "4,20 €" },
    { name: "Éclair au café", desc: "Crème pâtissière montée à notre espresso.", price: "3,80 €" },
    { name: "Cookie chocolat-noisette", desc: "Cœur fondant, noisettes torréfiées.", price: "2,80 €" },
  ],
  "petit-dejeuner": [
    { name: "Formule « Bonjour Rennes »", desc: "Boisson chaude, jus pressé, tartine beurrée.", price: "8,50 €" },
    { name: "Granola maison", desc: "Yaourt fermier, fruits de saison, miel de Bretagne.", price: "6,80 €", tags: ["Bio", "Végétarien"] },
    { name: "Œufs brouillés", desc: "Mouillettes de pain au levain beurrées.", price: "7,20 €" },
    { name: "Pancakes", desc: "Caramel au beurre salé, éclats de noisettes.", price: "7,50 €" },
    { name: "Tartine avocat & œuf poché", desc: "Pain au levain, citron vert, piment doux.", price: "8,90 €", tags: ["Végétarien"] },
  ],
  dejeuner: [
    { name: "Galette complète", desc: "Sarrasin, jambon blanc, œuf fermier, emmental.", price: "9,80 €", tags: ["Sans gluten"] },
    { name: "Quiche de saison", desc: "Légumes du marché, salade verte.", price: "9,50 €", tags: ["Végétarien"] },
    { name: "Croque au comté", desc: "Pain au levain, béchamel au comté affiné.", price: "10,50 €" },
    { name: "Soupe du jour", desc: "Pain au levain grillé, beurre demi-sel.", price: "7,50 €", tags: ["Végétarien"] },
    { name: "Plat du marché", desc: "Selon l'arrivage du matin, place des Lices.", price: "13,50 €" },
    { name: "Salade des Arcades", desc: "Chèvre chaud, pommes, noix, miel.", price: "11,50 €", tags: ["Végétarien", "Sans gluten"] },
  ],
};

export const HOURS = [
  { day: "Lundi", hours: "Fermé", match: (d) => d === 1 },
  { day: "Mardi — Vendredi", hours: "8 h 00 – 19 h 00", match: (d) => d >= 2 && d <= 5 },
  { day: "Samedi", hours: "9 h 00 – 19 h 00", match: (d) => d === 6 },
  { day: "Dimanche", hours: "9 h 00 – 13 h 00", match: (d) => d === 0 },
];

export const CONTACT = {
  address: "14 Place des Lices",
  city: "35000 Rennes",
  phone: "02 99 54 32 10",
  email: "bonjour@cafe-des-arcades.fr",
  mapsUrl:
    "https://www.google.com/maps/search/?api=1&query=14+Place+des+Lices+35000+Rennes",
};
